<template>
    <div class="image-container">
      <!-- <img v-if="isLoaded" :src="postImgCrs" :alt="postImgAlt" ref="img" @load="loaded" /> -->
      <div v-if="isLoaded" class="h-100 image-post" :style="`background-image: url(${postImgCrs})`" ></div>
      <div v-else
        class="image-placeholder h-100"
        :class="{ hidden: isLoaded }"
        aria-hidden="true"
        ref="placeholder"
      ></div>
      <!-- :style="{ height: `${placeholderHeight}px` }" -->
      
    </div>
</template>
  
  <script>
  import api from '@/api/index';

  export default {
    props: {
      // postId: {
      //   type: Number,
      //   required: true
      // },
      postImgCrs:{
        type: String,
        required: true
      },
      // postImgAlt:{
      //   type: String,
      // }
    },
    data() {
      return {
        isLoaded: false,
        intervalId: null,
        // loadedAspectRatio: null,
        // clientWidth: 0,
      };
    }, 
    computed: {
      /**
       * Calculates the height of the placeholder
       * via the images nativeWidth and nativeHeight.
       */
      // placeholderHeight() {
      //   if (!this.loadedAspectRatio) {
      //     return 0;
      //   }
  
      //   return this.clientWidth / this.loadedAspectRatio;
      // },
    },
    mounted() {
      // Start the loading animation
      // this.intervalId = setInterval(() => {
      //   this.isLoaded = !this.isLoaded;
      // }, 500)
      setTimeout(() => {
        // Create a new image object
        const img = new Image();
        // console.log(img)

        // When the image has finished loading, set isLoaded to true
        img.onload = () => {
          this.isLoaded = true;
        };

        // Set the src attribute of the image to start the loading process
        img.src = this.postImgCrs;
      }, 10);

      // const img = this.$refs.img;
      // const sizeInterval = setInterval(() => {
      //   if (img.naturalWidth) {
      //     clearInterval(sizeInterval);
      //     this.loadedAspectRatio = img.naturalWidth / img.naturalHeight;
      //   }
      // }, 10);
      // window.addEventListener("resize", this.updateClientWidth);
      // this.updateClientWidth();
    },
    methods: {
      // loaded() {
      //   // clearInterval(this.intervalId)
      //   // setTimeout(() => {
      //   //   this.isLoaded = true;
      //   // }, 500);
      // },
    },
  };
  </script>
  
  <style scoped>
    .image-container,
    img {
        max-width: 100%;
    }
    .image-post,
    .image-container{
      height: 280px;
      position: relative;
      background-repeat: no-repeat;
      background-position: 100%;
      background-size: cover;
    }
    
    .image-placeholder.hidden {
      display: block;
    }
    .image-placeholder {
        height: 100%!important;
        background: rgba(0, 0, 0, 0.2);
        background-image: linear-gradient(120deg,
            rgba(255, 255, 255, 0) 0%,
            rgba(255, 255, 255, 0) 40%,
            rgba(255, 255, 255, 0.8) 50%,
            rgba(255, 255, 255, 0) 60%,
            rgba(255, 255, 255, 0) 100%
        );
        background-position-x: -20vw;
        background-repeat: no-repeat;
        animation: shiny 1.5s infinite;
    }
  
  @keyframes shiny {
    0% {
      background-position-x: -20vw;
    }
    10% {
      background-position-x: -20vw;
    }
    75% {
      background-position-x: 20vw;
    }
    100% {
      background-position-x: 20vw;
    }
  }
  /* mobile */
  @media only screen and (max-device-width: 640px), only screen and (max-device-width: 667px), only screen and (max-width: 480px) and (orientation : landscape) {
    @keyframes shiny {
    0% {
      background-position-x: -100vw;
    }
    10% {
      background-position-x: -100vw;
    }
    75% {
      background-position-x: 100vw;
    }
    100% {
      background-position-x: 100vw;
    }
  }
  }
  </style>